import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ConfirmedChurnReport } from "@/features/office/reports/confirmed-churn";
import {
  filterSearchFragment,
  notificationSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

// Lenient URL schema (strict enums on URL params crash the page — see
// webapp-routing.md). `asOf` is the As-of month (absent = this month, "1",
// "-1" or `YYYY-MM`), `by` the breakdown; filter state follows the shared
// `filters-new` chip DSL, the six controls of Metabase dashboard 94.
const searchSchema = z.object({
  asOf: z.string().optional().catch(undefined),
  by: z.string().optional().catch(undefined),
  filters: z
    .object({
      market: withOperators(commaListSchema),
      accountManager: withOperators(commaListSchema),
      membershipType: withOperators(commaListSchema),
      cancelReason: withOperators(commaListSchema),
      tenure: withOperators(commaListSchema),
      ...notificationSearchFragment,
    })
    .optional(),
  ...filterSearchFragment,
  ...maskSearchFragment,
});

export const routeId = "/office/reports/confirmed-churn";
export const Route = createFileRoute("/office/reports/confirmed-churn")({
  validateSearch: searchSchema,
  component: ConfirmedChurnReport,
});
